enum INDEX_TIKTOK_MEDIA {
  USERNAME = 3,
  VIDEO_ID = 5
}

export default INDEX_TIKTOK_MEDIA
